import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=45dd4874&scoped=true"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"
import style0 from "./Section3.vue?vue&type=style&index=0&id=45dd4874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd4874",
  null
  
)

export default component.exports